if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
constructor() {
  super();

  // スマホのみ：拡大画像をタップで閉じる
  if (window.matchMedia('(max-width: 749px)').matches) {
    this.addEventListener('click', (event) => {
      // ×ボタンを押した時は元の処理を優先
      if (event.target.closest('button')) return;

      // 画像または画像コンテナをタップしたら閉じる
      if (
        event.target.tagName === 'IMG' ||
        event.target.closest('.product-media-modal__content') ||
        event.target.closest('[role="document"]')
      ) {
        this.hide();
      }
    });
  }
}

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
